// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/minus'
import Icon from 'vue-awesome/components/Icon'
Vue.component('v-icon', Icon)
Vue.config.productionTip = false
import VueTimeago from 'vue-timeago'
Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: undefined, // Default locale
  locales: {
    
  }
})
import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);

window._ = require('lodash')
window.firebase = require('firebase/app')
window.axios = require('axios')
require("firebase/auth");
require("firebase/database");
require("firebase/functions");
let config = {
  apiKey: "AIzaSyC4h1Brt8uC8vhuePBOqltQ1wiHrNuoqqQ",
  authDomain: "twitch-voting.firebaseapp.com",
  databaseURL: "https://twitch-voting.firebaseio.com",
  projectId: "twitch-voting",
  storageBucket: "twitch-voting.appspot.com",
  messagingSenderId: "292025785482"
};

window.firebaseApp = firebase.initializeApp(config)
window.db = firebaseApp.database()


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js